export function refillSavings(regular, refill, currency = 'USD') {
  if (!Number.isSafeInteger(regular) || !Number.isSafeInteger(refill) || regular <= 0 || refill < 0 || refill >= regular) return '';
  const discount = regular - refill;
  const amount = new Intl.NumberFormat('en-US', {style:'currency',currency}).format(discount / 100);
  const percent = new Intl.NumberFormat('en-US', {maximumFractionDigits:1}).format(discount / regular * 100);
  return `Save ${amount} (${percent}%)`;
}

function badge(parent, value) {
  if (!parent) return;
  let element = parent.querySelector(':scope > .rrx-purchase-savings');
  if (!value) { element?.remove(); return; }
  if (!element) { element=document.createElement('small');element.className='rrx-purchase-savings';parent.append(element); }
  if (element.textContent!==value) element.textContent=value;
}

export function refreshPurchaseSavings(root=document) {
  for (const panel of root.querySelectorAll('restartrx-white-label-start')) {
    let prices;
    try {prices=JSON.parse(panel.querySelector('[data-restartrx-price-map]')?.textContent??'{}');} catch {continue;}
    const id=panel.closest('product-form-component')?.querySelector('input[name="id"]')?.value;
    const entry=prices[String(id)];
    const price=panel.querySelector('[data-restartrx-option-price="auto_refill"]');
    if (!price) continue;
    let wrap=price.parentElement;
    if (!wrap.classList.contains('rrx-purchase-price-stack')) {
      wrap=document.createElement('span');wrap.className='rrx-purchase-price-stack';price.replaceWith(wrap);wrap.append(price);
    }
    badge(wrap,entry?refillSavings(entry.one_time_minor,entry.auto_refill_minor,entry.currency??'USD'):'');
  }
}

if (typeof document!=='undefined' && document.querySelector('restartrx-white-label-start')) {
  let queued=false;
  const schedule=()=>{if(queued)return;queued=true;requestAnimationFrame(()=>{queued=false;refreshPurchaseSavings();});};
  document.addEventListener('variant:update',schedule);
  document.addEventListener('change',schedule);
  new MutationObserver(schedule).observe(document.body,{childList:true,subtree:true});
  schedule();
}
